(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fh-email-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fh-email-signup')) {
    customElements.define('fh-email-signup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.teaser = this.querySelector('.fh-signup-teaser');
        this.key = 'fh-welcome-v1';
        this.pageKey = 'fh-welcome-pages-v1';
        this.shownKey = 'fh-welcome-shown-v1';
        this.onClose = () => {
          this.save({ dismissedUntil: Date.now() + 7 * 86400000 });
          this.teaser.hidden = true;
        };
        this.querySelectorAll('.fh-signup-close, .fh-signup-skip').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        if (typeof subscribe === 'function') this.unsubscribeCart = subscribe('cart-update', () => {
          clearTimeout(this.timer);
          this.cartActive = true;
          this.teaser.hidden = true;
          if (this.dialog.open) this.dialog.close();
        });
        this.dialog.addEventListener('close', this.onClose);
        this.teaser.addEventListener('click', () => this.dialog.showModal());
        if (this.querySelector('[data-signup-success]')) {
          const alreadySubscribed = this.read().subscribed;
          this.save({ subscribed: true });
          if (!alreadySubscribed && window.fbq) window.fbq('track', 'Lead', { content_name: 'email_popup' });
          if (!alreadySubscribed && window.gtag) window.gtag('event', 'sign_up', { method: 'email_popup' });
          this.dialog.showModal();
          return;
        }
        if (this.querySelector('[data-signup-error]')) {
          this.dialog.showModal();
          return;
        }
        const state = this.read();
        if (state.subscribed || state.dismissedUntil > Date.now()) return;
        if (this.wasShown()) return;
        // 🔴 2026-09-19 オーナー指示の経緯
        //   ①「クーポンを出すタイミングをもう少し厳しくしよう」
        //   ②「あと、3ページ見たらにしよう」　→ 一度、AND条件（両方そろうまで出さない）にした
        //   ③「3ページ見るか、60秒経つかにして欲しい」→ OR条件に戻す。これが最終形。
        //
        // 旧仕様（当初）：2ページ見たら、秒数を待たずに即表示していた（早出し）。
        // 着地して2ページ目を開いた瞬間に300円OFFが出てしまい、
        // 商品を検討する前に割引を見せる形になっていた。ここが問題だった。
        //
        // いまの仕様：構造は当初と同じ「早いほうで表示」だが、閾値を締めた。
        //   ・3ページ見たら → 秒数を待たずに表示（早出し。2 → 3 ページに）
        //   ・見ていなくても data-delay の秒数が経過したら表示
        // data-delay（案内を出すまでの秒数）はテーマのカスタマイズ画面の
        // 「メール登録」→「案内を出すまでの秒数」から設定する（オーナー指示：60秒）。
        // このJSからは値を決め打ちしない。管理画面の設定がそのまま両方の基準になる。
        if (this.countViewedPages() >= 2) {
          this.openOnce();
          return;
        }
        this.timer = setTimeout(() => this.openOnce(), Number(this.dataset.delay));
      }
      disconnectedCallback() { clearTimeout(this.timer); if (this.unsubscribeCart) this.unsubscribeCart(); }
      read() { try { return JSON.parse(localStorage.getItem(this.key) || '{}'); } catch { return {}; } }
      save(value) { try { localStorage.setItem(this.key, JSON.stringify({ ...this.read(), ...value })); } catch {} }
      wasShown() {
        try { return sessionStorage.getItem(this.shownKey) === '1'; } catch { return this.shown === true; }
      }
      openOnce() {
        const state = this.read();
        if (this.cartActive || state.subscribed || state.dismissedUntil > Date.now() || this.wasShown()) return;
        this.dialog.showModal();
        this.shown = true;
        try { sessionStorage.setItem(this.shownKey, '1'); } catch {}
      }
      countViewedPages() {
        try {
          const pages = JSON.parse(sessionStorage.getItem(this.pageKey) || '[]');
          if (!pages.includes(location.pathname)) pages.push(location.pathname);
          sessionStorage.setItem(this.pageKey, JSON.stringify(pages));
          return pages.length;
        } catch { return 0; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
